import { IWorkflowTask } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const getWorkflowTasks = (calculationId: string): Promise<IWorkflowTask[]> =>
  API.get(`/api/workflow/tasks/calculations/${calculationId}`).then(response => response?.data);
